import { useState } from 'react'

import { MdFileDownload } from 'react-icons/md'

import { Box, Icon } from '@chakra-ui/react'
import { QRCodeCanvas } from 'qrcode.react'

import { downloadQRasPNG } from '@/utils/downloadQRasPNG'

interface QRCodeIProps {
  id: string
  displayId: string
  name: string
}

export const CheckPointQRCode = ({ id, displayId, name }: QRCodeIProps) => {
  const [shouldShowDowload, setShowDownload] = useState(false)

  const onDownload = () => {
    downloadQRasPNG(name, displayId, 'qrCode')
  }

  const handleQRHover = (isHovering: boolean) => {
    setShowDownload(isHovering)
  }

  return (
    <Box border='1px solid #DCDFE4' borderRadius='6px'>
      <Box
        _hover={{
          bgColor: '#091E420F',
        }}
        alignItems='center'
        cursor='pointer'
        data-testid='checkpointPanel_editCheckpoint_QrCodeContainer'
        display='flex'
        flexDirection='row'
        onMouseEnter={() => handleQRHover(true)}
        onMouseLeave={() => handleQRHover(false)}
      >
        <Box>
          <Box p='20px' pb='10px' position='relative'>
            <QRCodeCanvas
              id='qrCode'
              level='H'
              size={720}
              style={{ width: 120, height: 120 }}
              value={id}
            />
            {shouldShowDowload && (
              <Box
                alignItems='center'
                bgColor='#e3e6ea'
                bottom='10px'
                data-testid='checkpointPanel_editCheckpoint_QrCodeDownloadButton'
                display='flex'
                justifyContent='center'
                left='20px'
                onClick={onDownload}
                pos='absolute'
                right='20px'
                top='20px'
              >
                <Icon
                  as={MdFileDownload}
                  height='50%'
                  opacity={1}
                  width='50%'
                />
              </Box>
            )}
          </Box>

          <Box color='#5C6C7A' fontSize='14px' ml='20px'>
            {displayId}
          </Box>
        </Box>
        <Box color='#282424' fontSize='15px' textAlign='center'>
          Download QR Code
        </Box>
      </Box>
    </Box>
  )
}
